import React, { FC } from 'react'
import { ArticleTileProps } from './ArticleTile.types'
import { ImageCompound } from '../ImageCompound'
import { RTECompound } from '../RTECompound'

export const ArticleTile: FC<ArticleTileProps> = props => {
  const { image, textBottom, textHeading, rating, inTwoParts } = props

  return (
    <div className='ArticleTile--content u-sizeFull'>
      {image && (
        <div className='ImageArticleTile u-textCenter'>
          <ImageCompound {...image} />
        </div>
      )}
      {inTwoParts && (
        <div className='tile--divideByTwo'>
          <div className='ratingleftWidth u-flex u-flexAlignItemsCenter u-flexJustifyCenter'>
            <div className='articleTile--Rating '>
              <RTECompound {...rating} />
            </div>
          </div>
          <div className='rightContentWidth'>
            <div className='u-paddingBottom32'>
              <RTECompound {...textHeading} />
            </div>
            <div>
              <RTECompound {...textBottom} />
            </div>
          </div>
        </div>
      )}
      {!inTwoParts && textHeading && (
        <div className='u-textCenter'>
          <RTECompound {...textHeading} />
        </div>
      )}
      {!inTwoParts && rating && (
        <div className='articleTile--Rating'>
          <RTECompound {...rating} />
        </div>
      )}
      {!inTwoParts && textBottom && (
        <div className='u-textCenter'>
          <RTECompound {...textBottom} />
        </div>
      )}
    </div>
  )
}
